// extracted by mini-css-extract-plugin
module.exports = {"spinning":"styles_spinning__vJ9r6","spin":"styles_spin__wVKlk"};